
import layerEvents from "../utils/layerEvents";
import { Button, Col, Row, Dropdown} from "react-bootstrap";
import { PencilSimple,Lightning, Windmill, BatteryCharging, BatteryFull, Spiral, Ruler, Crosshair, X, Info, Eye, Trash, DotsThreeVertical } from "@phosphor-icons/react";
import DataTable from 'react-data-table-component';
import {format_power} from "../utils/functions";

class ToolTurbineDetail {

	tabIndex = null;

	constructor(toolTurbine, turbineid, tabIndex) {
		this.tc = toolTurbine.tc;
		this.turbineid = turbineid;
		this.tt = toolTurbine;
		this.init();
	}
	init(){
		if(this.tc.serviceBar.current)
			this.tt.tabIndexDetail = this.tc.serviceBar.current.inject(this.render(), this.tt.tabIndexDetail);
		
		this.tt.selectOnMap(this.turbineid);
		
	}
	exit(){
		this.tt.deselectOnMap();
		if(this.tc.serviceBar.current)
			this.tc.serviceBar.current.clear(this.tt.tabIndexDetail);
		this.tt.tabIndexDetail = null;
	}

	render(){
		
		var wt = false;
		if(!(wt = this.tc.scenario.wtgs.find((a)=>{return a.turbineid == this.turbineid})))
			return;
		
		
		
		
		return (
			
			<div className={"project-turbines "}>
				<div className="title">
					Turbine {wt.name}
					<span onClick={(e)=>{this.exit()}} 	className="btn btn-close alt btn-sm float-end"><X size={16} /></span>
				</div>
				<div className="owner-body">

					<div className="separator">
						<span>About this turbine</span>
					</div>
					<div className="content  aep">
						<Row className="basic-info mb-2">
							<Col xs="12">
								<Windmill size={16} />
								<span>Type: </span>
								
								{this.tc.scenario.wtgSettings.turbineType ?? 'Not available'}
							</Col>
						</Row>
						<Row className="basic-info mb-2">
							<Col xs="12">
								<Ruler size={16} />
								<span>Hub height: </span>
								
								{this.tc.scenario.wtgSettings.hubHeight}m
							</Col>
						</Row>
						<Row className="basic-info mb-2">
							<Col xs="12">
								<Lightning size={16} />
								<span>Effect: </span>
								
								{format_power(wt.aep)}
							</Col>
						</Row>
						<Row className="basic-info mb-2">
							<Col xs="12">
								<Spiral size={16} />
								<span>Wake loss: </span>
								
								{wt.wakeloss} %
							</Col>
						</Row>
					</div>

				</div>

			</div>	
			
		);
		
	}
}

export default ToolTurbineDetail;